import { Textfit } from "react-textfit";
import "./NewsletterPickerRow.scss";
import { NLSenderProspect } from "@models/Models";
import { ReactComponent as VerifiedBadge } from "@images/verified_checkmark.svg";
import * as ElapsedDate from "@utils/Date+ElapsedInterval";
interface NewsletterPickerRowProps {
	prospect: NLSenderProspect;
	isChecked: boolean;
	checkOnChange: (senderId: number) => void;
	onPreview?: (messageId: string) => void;
}

export const NewsletterPickerRow = ({ prospect, isChecked, checkOnChange, onPreview }: NewsletterPickerRowProps) => {
	return (
		<div key={prospect.sender_id} className="relative">
			<label className={`flex p-[30px] flex-row w-full justify-between items-center gap-2 cursor-pointer select-newsletter-row transition ease-in-out ${isChecked ? "selected-sender" : "hover:bg-white/20"}`}>
				<div className="flex flex-row items-center text-left gap-3">
					<input readOnly className="checkbox-round" type="checkbox" name="selectable-sender" checked={isChecked} value={prospect.sender_id} onChange={() => checkOnChange(prospect.sender_id)} />
					<div className="flex flex-col gap-2">
						<div>
							<div className="flex flex-row items-center gap-1.5">
								<Textfit mode="single" className="text-white font-medium text-xl font-primary max-w-[250px]" max={20}>
									{prospect.sender_name}
								</Textfit>
								<VerifiedBadge className="w-[14px] h-[14px] fill-white" />
							</div>
							<Textfit mode="single" className="text-white/50 font-regular text-sm font-primary max-w-[250px]" max={14}>
								{prospect.sender_address}
							</Textfit>
						</div>
						{prospect.latest_message_date && <div className="text-white/50 font-regular text-xs font-primary">Last received: {ElapsedDate.elapsedInterval(prospect.latest_message_date)}</div>}
					</div>
				</div>
				{prospect.latest_message_id && (
					<button className={`absolute rounded-lg font-medium font-primary text-sm px-3 py-2 bg-white/50 text-white bottom-3 right-3`} onClick={(e) => { e.preventDefault(); onPreview && onPreview(prospect.latest_message_id!); }}>
						PREVIEW
					</button>
				)}
			</label>
		</div>
	);
};

export default NewsletterPickerRow;
